import { array, struct } from 'io-ts/Decoder';

import { Id as ProjectId } from '../../../project/Id';

export const Request = struct({
	projectIds: array(ProjectId),
});
